import { Component } from '@angular/core';

@Component({
  selector: 'app-searchbox',
  imports: [],
  templateUrl: './searchbox.html',
  styleUrl: './searchbox.css',
})
export class Searchbox {

}
